import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validateLength,
  validateConfirmation,
} from 'ember-changeset-validations/validators';

const resetPasswordValidation = {
  password: validateLength({
    min: 8,
    message: 'Your password must be at least 8 characters.',
  }),
  passwordConfirmation: validateConfirmation({ on: 'password' }),
};

export default Route.extend({
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Reset Password');
  },

  model(params) {
    return this.store
      .findRecord('reset-password', params.resetToken)
      .then((record) => {
        return {
          record: record,
          changeset: new Changeset(
            record,
            lookupValidator(resetPasswordValidation),
            resetPasswordValidation,
          ),
        };
      });
  },
});
